// emailService.js
import { firebase } from "common/src/config/configureFirebase";
import toast from "react-hot-toast";
import { push, serverTimestamp } from "firebase/database";

export const sendContactEmail = async (formData) => {
  try {
    const { contactRef } = firebase;

    const data = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      timestamp: serverTimestamp(),
    };
    push(contactRef, data);

    toast.success("Message sent successfully!", {
      duration: 5000,
      position: "top-center",
    });

    return { success: true };
  } catch (error) {
    console.error("Error sending contact message:", error);
    toast.error(error.message || "Failed to send message");
    return {
      success: false,
      error: error.message || "Failed to send message",
    };
  }
};
